import React, { useRef } from 'react';
import styled from '@emotion/styled';
import { Box } from 'theme-ui'
import { GatsbyImage as Img, getImage } from 'gatsby-plugin-image';
import Reveal from '@solid-ui-components/Reveal';
import { useHasBeenVisible } from '../../../hooks/useVisibility';
import FullWidthPlaceHolder from '../../../content/components/shared/FullWidthPlaceHolder';
import Video from './Video';

const styles = {
  sixthItem: {
    width: `20%`,
  },
  link: {
    width: `70%`,
  },
};

const PublicationsWrapper = styled.div`
  background-color: #7777770a;
  height: auto;
  width: 100%;
  padding-top: 40px
`;

const PublicationsContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

const PublicationsTitle = styled.h1`
  color: #000;
  line-height: 1.3;
  margin-bottom: 0.5em;
  font-weight: bold;
  text-align: center;
  width: 100%;
  margin-top: 0;
  margin-bottom: 40px;
`;
const PublicationsRow = styled.div`
  width: 100%;
  display: flex;
  flex-flow: row wrap;
  max-width: 1080px;
`;

const PublicationCard = styled(Reveal)`
  width: 25%;
  @media (max-width: 549px) {
    width: ${({ index }) => {
    if ([4, 7].includes(index)) return '100%';
    return '50%';
  }};
  }
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 15px 30px;
`;

const checkWidth = (index, company) => {
  if (index === 5 && company.alt !== 'Adslzone') {
    return styles.sixthItem;
  } else {
    return styles.link;
  }
};


const VIDEOIDS = [
  'n4j90vzkfB8',
  'jwrifC0om6Q',
  'gwT-0nZ2rUk'
]

const PublicationsColumns = ({ companies }) => {
  return (
    <>
      {companies.map((company, index) => (
        <PublicationCard index={index} key={index} effect='fadeInPop'>
          <a href={company?.link} style={checkWidth(index, company)}>
            <Img
              image={getImage({
                ...company?.src?.ImageSharp_medium,
                __typename: 'ImageSharp_medium',
              })}
              alt={company.alt}
            />
          </a>
        </PublicationCard>
      ))}
    </>
  );
};

const videoStyles = {
  container: {
    width: '100%', display: 'flex', flexDirection: ['column', 'row'], padding: ['20px 10px', '20px 0']
  },
  item: {
    width: '100%',
    height: 250,
    margin: ['20px 0', '0 20px']
  }
}
const PublicationVideo = () => <Box sx={videoStyles.container}>
  {VIDEOIDS.map(videoId => (
    <Box sx={videoStyles.item}>
      <Video videoId={videoId} />
    </Box>
  ))}
</Box>

const Publications = ({ showVideo = false, content, style }) => {
  const publicRef = useRef();
  const hasScrolled = useHasBeenVisible(publicRef);

  return (
    <PublicationsWrapper style={style}>
      <PublicationsTitle>{content?.title?.text}</PublicationsTitle>
      {hasScrolled ? (
        <PublicationsContainer>
          {showVideo ?
            <PublicationVideo />
            : (<PublicationsRow>
              <PublicationsColumns companies={content.images} />
            </PublicationsRow>)}
        </PublicationsContainer>
      ) : (
        <FullWidthPlaceHolder
          reference={publicRef}
          customStyle={{ height: '270px !important', backgroundColor: 'transparent' }}
        />
      )}
    </PublicationsWrapper>
  );
};

export default Publications;
